export const FACTOR = 0.621371;

class Distance {
    metres = 0;
    isImperial = false;

    constructor(metres: number, isImperial: boolean) {
        this.metres = metres;
        this.isImperial = isImperial;
    }

    kilometres(): number {
        return this.metres / 1000;
    }

    miles(): number {
        return this.kilometres() * FACTOR;
    }

    distance(): number {
        return this.isImperial ? this.miles() : this.kilometres();
    }

    toString(): string {
        return this.isImperial
            ? `${this.miles().toFixed(1)} mi`
            : `${this.kilometres().toFixed(2)} km`;
    }
}

export default function convertDistance(
    metres: number | null,
    isImperial: boolean | null
): Distance {
    return new Distance(metres ?? 0, isImperial ?? false);
}

export const convertDistanceForCurrentSetting = (r: number, setting: boolean | null = false): string =>
    convertDistance(r * 1000, setting).toString();
